"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setDefaultsFromContext", {
  enumerable: true,
  get: function get() {
    return _ApiClient.setDefaultsFromContext;
  }
});
Object.defineProperty(exports, "installAuthInterceptor", {
  enumerable: true,
  get: function get() {
    return _ApiClient.installAuthInterceptor;
  }
});
Object.defineProperty(exports, "removeAuthInterceptor", {
  enumerable: true,
  get: function get() {
    return _ApiClient.removeAuthInterceptor;
  }
});
Object.defineProperty(exports, "makeApiService", {
  enumerable: true,
  get: function get() {
    return _ApiClient.makeApiService;
  }
});
Object.defineProperty(exports, "makeMockedApiService", {
  enumerable: true,
  get: function get() {
    return _ApiClient.makeMockedApiService;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ApiClient.ApiClient;
  }
});

var _ApiClient = require("./ApiClient");